import React, { createContext, useContext } from "react";
import { FormProvider } from "react-hook-form";
import { ProfileEDBContextType } from "../types/profileEDB.types";
import { useProfileEDBLogic } from "../hooks/useProfileEDBLogic";

export const ProfileEDBContext = createContext<
  ProfileEDBContextType | undefined
>(undefined);

export const useProfileEDBContext = () => {
  const context = useContext(ProfileEDBContext);
  if (context === undefined) {
    throw new Error(
      "useProfileEDBContext must be used within an ProfileEDBProvider"
    );
  }
  return context;
};

interface ProfileEDBProviderProps {
  children: React.ReactNode;
  idEdb: string | null;
}

export const ProfileEDBProvider = ({
  children,
  idEdb,
}: ProfileEDBProviderProps) => {
  const value = useProfileEDBLogic({ idEdb });
  const { formMethods, ...restValue } = value;

  return (
    <ProfileEDBContext.Provider value={restValue}>
      <FormProvider {...formMethods}>{children}</FormProvider>
    </ProfileEDBContext.Provider>
  );
};
